module.exports = __webpack_public_path__ + "img/linkedin-white.6e667b0d.svg";